import { render, staticRenderFns } from "./SortControl.vue?vue&type=template&id=2006282a&scoped=true&"
import script from "./SortControl.vue?vue&type=script&lang=js&"
export * from "./SortControl.vue?vue&type=script&lang=js&"
import style0 from "./SortControl.vue?vue&type=style&index=0&id=2006282a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006282a",
  null
  
)

export default component.exports